import React from "react";
import { Outlet } from "react-router-dom";

const MobileProfileWrapper: React.FC = () => <Outlet />;
export default MobileProfileWrapper;
